export const sanitizePhone = (value) => value.replace(/[^0-9+()\- ]/g, '')

export const isPhoneCharactersValid = (value) => /^(?=.*\d)[0-9+()\- ]+$/.test(value)

export const sanitizeEmail = (value) => value.replace(/[^A-Za-z0-9._%+\-@]/g, '')

export const isEmailCharactersValid = (value) => /^[A-Za-z0-9._%+\-@]+$/.test(value)
